import React from "react";
import {withTranslation} from "react-i18next";
import {Text, View} from "@react-pdf/renderer";

function CardStudentPdf(props) {

    const {t, i18n,studentProfile,stylesPdf, year,studentHistory} = props;

    return (
        <View style={stylesPdf.rowheader}>
            <View style={{marginTop: 5, flexDirection: "row",backgroundColor: "#FFB81C", borderTopLeftRadius: 30, borderTopRightRadius: 30}}>
                <View style={{width: "100%",textAlign: "left", paddingLeft: 10, paddingTop: 5, paddingBottom: 5}}>

                    <Text style={stylesPdf.h1HeaderTable}>{t("informes.card.title")}: </Text>
                </View>
            </View>
            <View style={{flexDirection: "row",
                borderBottom: 1, borderBottomColor: '#FAFAFA',
                borderLeft: 1, borderLeftColor: '#FAFAFA',borderRight: 1, borderRightColor: '#FAFAFA'}}>
                <View style={{width: "40%", backgroundColor: '#FAFAFA', textAlign: "left", paddingLeft: 24, paddingTop: 8}}>
                    <View style={stylesPdf.lineText}>
                        <Text style={stylesPdf.strongText2}>{t("tutores.informes.tableename")}: </Text>
                    </View>
                </View>
                <View style={{width: "60%", textAlign: "left", paddingLeft: 5, paddingTop: 8}}>
                    <View style={stylesPdf.lineText}>
                        <Text style={stylesPdf.paddingTextCenter}>{studentProfile?.name} {studentProfile?.surname}</Text>
                    </View>
                </View>
            </View>

            <View style={{flexDirection: "row",
                borderBottom: 1, borderBottomColor: '#FAFAFA',
                borderLeft: 1, borderLeftColor: '#FAFAFA',borderRight: 1, borderRightColor: '#FAFAFA'}}>
                <View style={{width: "40%", backgroundColor: '#FAFAFA',textAlign: "left", paddingLeft: 24, paddingTop: 8}}>
                    <View style={stylesPdf.lineText}>
                        <Text style={stylesPdf.strongText2}>{t("registro.centro")}: </Text>
                    </View>
                </View>
                <View style={{width: "60%", textAlign: "left", paddingLeft: 5, paddingTop: 8}}>
                    <View style={stylesPdf.lineText}>
                        <Text style={stylesPdf.paddingTextCenter}>{studentProfile?.center?.name}</Text>
                    </View>
                </View>
            </View>

            <View style={{flexDirection: "row",
                borderBottom: 1, borderBottomColor: '#FAFAFA',
                borderLeft: 1, borderLeftColor: '#FAFAFA',borderRight: 1, borderRightColor: '#FAFAFA'}}>
                <View style={{width: "40%", backgroundColor: '#FAFAFA',textAlign: "left", paddingLeft: 24, paddingTop: 8}}>
                    <View style={stylesPdf.lineText}>
                        <Text style={stylesPdf.strongText2}>{t("datos.year")}: </Text>
                    </View>
                </View>
                <View style={{width: "60%", textAlign: "left", paddingLeft: 5, paddingTop: 8}}>
                    <View style={stylesPdf.lineText}>
                        <Text style={stylesPdf.paddingTextCenter}>{"20" + (+year) + "/20"  + (+year+1)}</Text>
                    </View>
                </View>
            </View>

            <View style={{flexDirection: "row",
                borderBottom: 1, borderBottomColor: '#FAFAFA',
                borderLeft: 1, borderLeftColor: '#FAFAFA',borderRight: 1, borderRightColor: '#FAFAFA'}}>
                <View style={{width: "40%", backgroundColor: '#FAFAFA',textAlign: "left", paddingLeft: 24, paddingTop: 8}}>
                    <View style={stylesPdf.lineText}>
                        <Text style={stylesPdf.strongText2}>{t("login.course")}: </Text>
                    </View>
                </View>
                <View style={{width: "60%", textAlign: "left", paddingLeft: 5, paddingTop: 8}}>
                    <View style={stylesPdf.lineText}>
                        <Text style={stylesPdf.paddingTextCenter}>{studentHistory?.course?.name}</Text>
                    </View>
                </View>
            </View>

            <View style={{flexDirection: "row",
                borderBottom: 1, borderBottomColor: '#FAFAFA',
                borderLeft: 1, borderLeftColor: '#FAFAFA',borderRight: 1, borderRightColor: '#FAFAFA'}}>
                <View style={{width: "40%", backgroundColor: '#FAFAFA',textAlign: "left", paddingLeft: 24, paddingTop: 8}}>
                    <View style={stylesPdf.lineText}>
                        <Text style={stylesPdf.strongText2}>{t("login.group")}: </Text>
                    </View>
                </View>
                <View style={{width: "60%", textAlign: "left", paddingLeft: 5, paddingTop: 8}}>
                    <View style={stylesPdf.lineText}>
                        <Text style={stylesPdf.paddingTextCenter}>{(studentHistory && studentHistory.group) ?? studentProfile.group}</Text>
                    </View>
                </View>
            </View>

            <View style={{flexDirection: "row",
                borderBottom: 1, borderBottomColor: '#FAFAFA',
                borderLeft: 1, borderLeftColor: '#FAFAFA',borderRight: 1, borderRightColor: '#FAFAFA'}}>
                <View style={{width: "40%", backgroundColor: '#FAFAFA',textAlign: "left", paddingLeft: 24, paddingTop: 8}}>
                    <View style={stylesPdf.lineText}>
                        <Text style={stylesPdf.strongText2}>{t("informes.card.email")}: </Text>
                    </View>
                </View>
                <View style={{width: "60%", textAlign: "left", paddingLeft: 5, paddingTop: 8}}>
                    <View style={stylesPdf.lineText}>
                        <Text style={stylesPdf.paddingTextCenter}>{studentProfile?.username}</Text>
                    </View>
                </View>
            </View>





        </View>
    )}

export default withTranslation()(CardStudentPdf);
